
import UiIcon from "~/components/UI/UiIcon.vue";

export default {
  name: "ArticleCard",
  components: {
    UiIcon,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    articleCategory() {
      const activeArticleCategories = this.article?.categories?.filter((el) => el.status) || [];
      const currentCategory = activeArticleCategories?.find(
        (el) => el.slug === this.$route.params?.section
      );
      return currentCategory || activeArticleCategories?.[0];
    },
    articleLink() {
      return this.localePath(
        `/articles/${this.articleCategory?.slug || "all"}/${
          this.article?.slug
        }`
      );
    },
    image() {
      return this.article?.medias?.find((el) => el.position === "list") || "";
    },
  },
};
